import ko from 'knockout';
import {
  formatInteger,
} from '@bingads-webui-campaign/recommendation-core';

export default class ViewModel {
  constructor({
    i18n,
  }) {
    this.i18n = i18n;
    this.campaignsCount = ko.observable('');
  }

  updateAttribute({ campaignsCount }) {
    const { i18n } = this;
    this.campaignsCount(i18n.getString(
      'Shared_Budget_Recommendation_CampaignCount',
      { campaignsCount: formatInteger(campaignsCount, this.i18n) }
    ));
  }
}
